import React from 'react';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';

const MIReportApproval = ({ yearMonth, context, reportExists }) => {
  const [approving, setApproving] = React.useState(false);
  const [approved, setApproved] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    setApproved(false);
  }, [yearMonth && yearMonth.year, yearMonth && yearMonth.month]);

  const handleApprove = () => {
    if (!window.confirm(
      'Are you sure you want to approve the Monitoring Intelligence report for ' +
      (yearMonth ? yearMonth.monthName + ' ' + yearMonth.year : '') +
      '?\n\nClick OK to confirm.'
    )) return;

    setApproving(true);
    setError(null);

    const body = yearMonth ? { year: yearMonth.year, month: yearMonth.month } : {};

    RestApiUtils.post(
      context,
      '/api/su/monitoringIntelligence/miReportSendApprovalEmail',
      (data) => {
        setApproving(false);
        if (data && (data.success === 'OK' || data.success)) {
          setApproved(true);
        } else {
          const msg = data && data.errorList && data.errorList[0]
            ? data.errorList[0].message
            : 'Failed to send email. Please try again.';
          setError(msg);
        }
      },
      body
    );
  };

  if (!reportExists) return null;

  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: '8px',
      padding: '6px 12px',
      background: approved ? 'var(--color-background-success)' : 'var(--color-background-secondary)',
      border: '1px solid',
      borderColor: approved ? 'var(--color-border-success)' : 'var(--color-border-secondary)',
      borderRadius: '6px', marginBottom: '12px',
      fontSize: '0.82rem',
    }}>
      {approved ? (
        <span style={{ color: 'var(--color-text-success)', fontWeight: 600 }}>
          ✓ Report emailed.
        </span>
      ) : (
        <>
          <input
            type="checkbox" id="mi-approve-email"
            checked={false} onChange={handleApprove}
            disabled={approving}
            style={{ width: '13px', height: '13px', cursor: 'pointer', margin: 0 }}
          />
          <label htmlFor="mi-approve-email"
            style={{ cursor: approving ? 'wait' : 'pointer', fontWeight: 500, margin: 0 }}>
            {approving ? 'Sending...' : 'Approve & email Monitoring Intelligence summary'}
          </label>
          {error && (
            <span style={{ color: 'var(--color-text-danger)', fontSize: '0.78rem' }}>{error}</span>
          )}
        </>
      )}
    </div>
  );
};

export default MIReportApproval;